import { render } from "./LocaleSwitcher.vue?vue&type=template&id=0cbec22f&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=0cbec22f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbec22f"]])

export default __exports__